import DebtorsScreen from './debtors';

export {DebtorsScreen};
